import * as types from './mutation-types'

export default {
  [types.SET_PRACTICE_INFO] (state, data) {
    state.practiceInfo = data
  }
}
